import React, { useEffect, useState } from 'react'
import { Views } from '../../views'
import { connect } from 'react-redux'
import { get, isEmpty } from 'lodash'
import { destroyRocketChatInfo, getAuthMethod, routersHelper, setCookie } from '../../helpers'
import { SAVE_VROOM_TOKEN, SET_LANGUAGE } from '../../redux/actions/type'
import { useDispatch } from 'react-redux'
import i18n from '../../i18n'



const Participant = ({ language, switchLanguage }) => {
    const { Participant } = Views
    const { useRouter } = routersHelper
    const router = useRouter()
    const { match: { params } } = router
    const { name } = params
    const { query: { jwt, lang } } = router
    const dispatch = useDispatch()
    const [reservationId, setReservationId] = useState(null)


    useEffect(() => {
        if (isEmpty(name)) {
            window.location.href = window._env_.vRoomUrl
        }

        if (jwt) {
            window.history.pushState('', 'VROOM', `/${name}`);
            dispatch({
                type: SAVE_VROOM_TOKEN,
                payload: {
                    jwt
                }
            })
        }
    })

    useEffect(() => {
        const initParticipant = async () => {
            try {
                //clear old rocketChatInfo
                await destroyRocketChatInfo()
                //get reservation id
                const { id } = await getAuthMethod(name)
                setReservationId(id)
            } catch (error) {
                console.error('initParticipant', error)
            }
        }
        const changeLanguage = (lng) => {
            i18n.changeLanguage(lng)
            setCookie('language', lng)
            switchLanguage(lng)
        }

        initParticipant()

        if (!isEmpty(lang) && lang.toLowerCase() === 'th') {
            changeLanguage('th')
        } else if (!isEmpty(lang) && lang.toLowerCase() === 'zhcn') {
            changeLanguage('cn')
        } else {
            changeLanguage('en')
        }
    }, [name, lang, switchLanguage])

    return (
        <Participant
            language={language}
            roomName={name}
            jwt={jwt}
            reservationId={reservationId}
        />
    )
}

const mapStateToProps = state => ({
    language: get(state, 'language', 'th')
})

const mapDispatchToProps = dispatch => ({
    switchLanguage: (lang) => {
        dispatch({
            type: SET_LANGUAGE,
            payload: lang
        })
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Participant)